export default "__VITE_ASSET__305c2113__"